






import _ from "lodash";
import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class VProxyWindow extends Vue {
  @Prop({ default: 100 }) wait!: number;

  width = 0;
  height = 0;

  handle = _.debounce(this.update, this.wait);

  mounted() {
    this.update();
    window.addEventListener("resize", this.handle);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.handle);
  }

  update() {
    this.width = this.$el.clientWidth;
    this.height = this.$el.clientHeight;
    this.$emit("change", { width: this.width, height: this.height });
  }
}
